import React, { useState, useEffect } from 'react';
import { FaBars, FaSearch, FaBell, FaUserCircle, FaMoon, FaSun } from 'react-icons/fa';
import './Navbar.css';

const Navbar = ({ toggleSidebar }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: 'New user registration', time: '5 mins ago', unread: true },
    { id: 2, message: 'Withdrawal request pending', time: '10 mins ago', unread: true },
    { id: 3, message: 'Deposit confirmed', time: '1 hour ago', unread: false },
  ]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
    // Check for saved theme preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setDarkMode(true);
      document.body.classList.add('dark-mode');
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  };

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <FaBars />
        </button>
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search..."
            className="search-input"
          />
        </div>
      </div>

      <div className="navbar-right">
        {/* Theme Toggle */}
        <button className="nav-icon-btn theme-toggle" onClick={toggleDarkMode}>
          {darkMode ? <FaSun /> : <FaMoon />}
        </button>

        {/* Notifications */}
        <div className="notification-wrapper">
          <button
            className="nav-icon-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FaBell />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>

          {showNotifications && (
            <div className="notification-dropdown">
              <div className="dropdown-header">
                <h6>Notifications</h6>
                <span className="badge bg-primary">{unreadCount} New</span>
              </div>
              <div className="notification-list">
                {notifications.map(notification => (
                  <div
                    key={notification.id}
                    className={`notification-item ${notification.unread ? 'unread' : ''}`}
                  >
                    <div className="notification-content">
                      <p>{notification.message}</p>
                      <small>{notification.time}</small>
                    </div>
                  </div>
                ))}
              </div>
              <div className="dropdown-footer">
                <a href="/notifications">View All Notifications</a>
              </div>
            </div>
          )}
        </div>

        {/* Profile */}
        <div className="profile-wrapper">
          <button
            className="profile-btn"
            onClick={() => setShowProfile(!showProfile)}
          >
            <FaUserCircle className="profile-icon" />
            <div className="profile-info">
              <span className="profile-name">Admin User</span>
              <small className="profile-role">Administrator</small>
            </div>
          </button>

          {showProfile && (
            <div className="profile-dropdown">
              <a href="/profile" className="dropdown-item">My Profile</a>
              <a href="/settings" className="dropdown-item">Settings</a>
              <hr className="dropdown-divider" />
              <a href="/logout" className="dropdown-item">Logout</a>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;